<template>
  <div>
    <div class="row bg-grey pt-3">
      <div class="col-12">
        <h3 class="title-h3 border-bottom pb-3">
          <button type="button" class="btn btn-back" @click="$router.push('/trucks')" />
          Back
        </h3>
      </div>
    </div>
    <form @submit.prevent="save" @keydown="clearError($event)" autocomplete="no">
      <div class="l-bg-white">
        <div class="row my-4">
          <div class="col-3">
            <div class="select-wrap">
              <label>Truck name</label>
              <input v-model="truck.name" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Licence plate</label>
              <input v-model="truck.licence_plate" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="licence_plate" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Size</label>
              <simple-select v-model="truck.truck_size_id"
                             :options="truck_sizes"
                             placeholder="Select Size"
              />
            </div>
            <error-field :errors="errors" field="truck_size_id" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Seats</label>
              <input v-model="truck.number_of_seats" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="number_of_seats" />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-3">
            <div class="select-wrap">
              <label>Carrier</label>
              <simple-select v-model="truck.carrier_id"
                             :options="carriers"
                             placeholder="Select Carrier"
              />
            </div>
            <error-field :errors="errors" field="carrier" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Status</label>
              <simple-select v-model="truck.status_id"
                             :options="truckStatuses"
                             placeholder="Select Carrier"
              />
            </div>
            <error-field :errors="errors" field="status_id" />
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-3">
            <div class="select-wrap">
              <label>Make</label>
              <input v-model="truck.make" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="make" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Model</label>
              <input v-model="truck.model" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="model" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Year</label>
              <input v-model="truck.year" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="year" />
          </div>
          <div class="col-3">
            <div class="select-wrap">
              <label>Zip</label>
              <input v-model="truck.zip" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="zip" />
          </div>
        </div>

        <!-- Files -->
        <FilesUpload :sources="truck.images"
                     :model="'trucks'"
                     :model-id="parseInt($route.params.id)"
                     @update="getTruck"
        />

        <div class="row mx-0">
          <div class="col py-2 px-0 text-right">
            <button type="button" class="btn btn-delete float-left"
                    v-if="$_can('carriers.trucks.destroy')"
                    @click="remove({carrierId: carrier, truckId: truck.id})"
            >
              Delete
            </button>
            <button type="button"
                    @click="getTruck"
                    class="btn btn-secondary"
            >
              Discard
            </button>
            <button class="btn btn-primary ld-ext-right"
                    v-if="$_can('carriers.trucks.update')"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </form>
    <trucks-calendar />
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import TrucksCalendar from './TrucksCalendar';
import FilesUpload from '../FilesUpload';

export default {
  components: {
    FilesUpload,
    ErrorField,
    TrucksCalendar,
  },
  data: () => ({
    carrier: null,
    truck_sizes: [],
    truck: {
      color: '',
      carrier_id: null,
      images: [],
      licence_plate: '',
      make: '',
      model: '',
      name: '',
      truck_size_id: null,
      status: [],
      status_id: '',
      year: '',
      number_of_seats: null,
      zip: '',
    },
    loadingButton: false,
    buttonDisabled: false,
    errors: new Errors(),
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      truckStatuses: state => state.values.truckStatuses,
    }),
  },
  mounted() {
    this.getTruckStatuses();
    this.getTruck();
    axios
      .get(`/values/truck-sizes`)
      .then(res => {
        this.truck_sizes = res.data.data;
      })
      .catch(err => this.errors.record(err.response.data.error));
  },
  methods: {
    ...mapActions(['getTruckStatuses', 'removeTruck']),
    getTruck() {
      axios
        .get(`trucks/${this.$route.params.id}`)
        .then(result => {
          this.truck = result.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    save() {
      this.loadingButton = true;
      this.buttonDisabled = true;
      if (!this.truck.carrier_id) {
        this.errors.record({ carrier: ['Carrier field is required.'] });
        this.buttonDisabled = false;
        this.loadingButton = false;
      } else {
        axios
          .put(`trucks/${this.$route.params.id}`, { ...this.truck })
          .then(() => {
            toastr.success('Successfully updated truck');
            this.$router.push('/trucks');
          })
          .catch(err => {
            this.errors.record(err.response.data.error);
          })
          .finally(() => {
            this.loadingButton = false;
            this.buttonDisabled = false;
          });
      }
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    remove(carrierId, truckId) {
      this.removeTruck(carrierId, truckId)
        .then(() => {
          this.$router.push('/trucks');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/trucks/TrucksEdit.vue